import React, {useEffect, useState} from "react";
import WheelOfWalt from "../components/WheelOfWalt";
import Confetti from 'react-confetti'
// import {Col, Row} from "react-bootstrap";
// import vanna from 'public/images/wheel_of_fortune_vanna_white.gif'

function WaltYouDidIt() {
    const [windowSize, setWindowSize] = useState(getWindowSize());
    useEffect(() => {
        function handleWindowResize() {
            setWindowSize(getWindowSize());
        }

        window.addEventListener('resize', handleWindowResize);

        return () => {
            window.removeEventListener('resize', handleWindowResize);
        };
    }, []);


    return (
        <div>
            <Confetti
                width={windowSize.innerWidth}
                height={windowSize.innerHeight}
            />

            <h1 className={"banner_heading"}>Walt YOU DID IT!!!!!</h1>
            <br />

            <div style={{
                margin: 'auto',
                width: '50%',
                padding: '10px',
            }}>
                {/*<Row>*/}
                {/*    <Col>*/}
                {/*        <img src={vanna} alt={'vanna'}/>*/}
                {/*    </Col>*/}
                {/*    <Col>*/}
                        <WheelOfWalt />
                    {/*</Col>*/}
                {/*</Row>*/}


            </div>


        </div>
    )
}

function getWindowSize() {
    const {innerWidth, innerHeight} = window;
    return {innerWidth, innerHeight};
}

export default WaltYouDidIt

